'use client';

import CartItem from '@/components/cart/cart-item';
import CartSelectAll from '@/components/cart/cart-select-all';
import CartSelectDelete from '@/components/cart/cart-select-delete';
import { useDictionary } from '@/lib/context/locale-provider';
import { Languages } from '@/lib/dictionaries';
import { Cart } from '@/schema/cart';
import React from 'react';
import '@/app/input.css';

function CartList({
  lang,
  carts,
  dataDate,
}: {
  lang: Languages;
  carts: Cart[];
  dataDate: number;
}) {
  const dict = useDictionary();

  const currency = dict!.common.currency.replace('원', 'KRW');

  return (
    <div>
      <div className="px-[5px] pb-5 w-full inline-flex flex-row justify-between items-center">
        <CartSelectAll
          serials={
            carts && carts.length > 0
              ? carts.flatMap((cart: Cart) =>
                  cart.cart.result
                    .filter(option => !option.isSoldOut)
                    .map(option => option.serial),
                )
              : []
          }
        />
        <CartSelectDelete />
      </div>
      {carts &&
        carts.length > 0 &&
        carts.map((cart: any) => (
          <CartItem
            key={cart.id}
            cart={cart}
            lang={lang}
            currency={currency}
            dataDate={dataDate}
          />
        ))}
    </div>
  );
}

export default CartList;
